export default "__VITE_ASSET__40d36465__"